import * as React from 'react';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  LinearProgress
} from '@material-ui/core';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import { DocumentCard } from '.';
import { Tabs, Tab } from '@material-ui/core';
import { timestampToString } from '../utils';

const styles: StyleRulesCallback = t => ({
  content: {
    backgroundColor: t.palette.grey['300'],
    padding: t.spacing.unit * 2
  },
  strip: {
    overflowX: 'scroll',
    display: 'flex',
    flexDirection: 'row'
  },
  padding: {
    padding: t.spacing.unit
  }
});

interface Props {
  status?: FieldStatus | null; 
  layers: RasterDocument[] | null;
  show: boolean;
  onSelect: (layer: RasterDocument) => void;
  onDismiss: () => void;
}

interface State {
  tab: string;
  kinds: string[];
}

class SelectLayerDialog extends React.PureComponent<Props & WithStyles, State> {
  state = {
    tab: 'ndvi',
    kinds: ['raster-ndvi']
  };

  renderLayer(layer: RasterDocument) {
    const { onSelect, classes } = this.props;
    return (
      <div className={classes.padding}>
        <DocumentCard
          kind={layer.kind}
          source={layer.sceneSource}
          meanNdvi={layer.meanNdvi}
          thumbnailUrl={layer.thumbnailUrl}
          date={timestampToString(layer.capturedOn)}
          selectable={false}
          onClick={() => onSelect(layer)}
        />
      </div>
    );
  }

  renderStrip(layers: RasterDocument[]) {
    const { classes } = this.props;
    const { kinds } = this.state;
    return (
      <div className={classes.strip}>
        {layers.filter(d => kinds.some(k => d.kind === k)).map(l => this.renderLayer(l))}
      </div>
    );
  }

  render() {
    const { layers, status, show, onDismiss, classes } = this.props;
    const { tab } = this.state;

    return (
      <Dialog
        open={show}
        fullWidth={true}
        maxWidth="md"
        onClose={() => onDismiss()}
        onBackdropClick={() => onDismiss()}
        onEscapeKeyDown={() => onDismiss()}
      >
        <DialogTitle>Seleccionar Capa</DialogTitle>
        {status && !status.ready && <DialogContent>
          <DialogContentText>
            Este lote aun se encuentra en procesamiento, agregaremos imágenes a
            medida que sean generadas, pero puede utilizar las actuales mientras
            tanto.
          </DialogContentText>
          <LinearProgress color="secondary" variant="determinate" value={status.progress * 100} />
        </DialogContent>}
        <Tabs value={tab} indicatorColor="primary" textColor="primary">
          <Tab
            value="ndvi"
            label="NDVI"
            onClick={() => this.setState({ tab: 'ndvi', kinds: ['raster-ndvi'] })}
          />
          <Tab
            value="truecolor"
            label="Color Verdadero"
            onClick={() => this.setState({ tab: 'truecolor', kinds: ['raster-truecolor'] })}
          />
          <Tab
            value="falsecolor"
            label="Falso Color"
            onClick={() => this.setState({ tab: 'falsecolor', kinds: ['raster-falsecolor'] })}
          />
          <Tab
            value="yield"
            label="Productividad"
            onClick={() => this.setState({ tab: 'yield', kinds: ['yield-analysis'] })}
          />
          <Tab
            value="elevation"
            label="Altimetría"
            onClick={() => this.setState({ tab: 'elevation', kinds: ['raster-dem', 'raster-slope'] })}
          />
        </Tabs>
        <DialogContent className={classes.content}>
          {layers && this.renderStrip(layers)}
          {layers &&
            !layers.length && (
              <DialogContentText>No hay capas disponibles</DialogContentText>
            )}
        </DialogContent>
      </Dialog>
    );
  }
}

export default withStyles(styles)(SelectLayerDialog);



// WEBPACK FOOTER //
// ./src/components/SelectLayerDialog.tsx